import { ContextColumnId } from "components/Environment/constants/contextTable";
import { EnvVariablesColumnId } from "components/Environment/constants/envVariableTable";
import { FilesColumnId } from "components/Environment/constants/mountedFilesTable";
import { SpaceliftVarsColumnId } from "components/Environment/constants/spaceliftVarsTable";
import { TableCellPerColumn } from "ds/components/TableSimple/types";
import { StackContextAttachment } from "types/generated";

import ContextDescriptionCell from "./ContextDescriptionCell";
import ContextNameCell from "./ContextNameCell";
import DescriptionCell from "./DescriptionCell";
import EmptyActionsCell from "./EmptyActionsCell";
import EnvVariableActionsCell from "./EnvVariableActionsCell";
import MountedFilesActionsCell from "./MountedFilesActionsCell";
import NameCell from "./NameCell";
import SecretCell from "./SecretCell";
import SourceCell from "./SourceCell";
import TimestampCell from "./TimestampCell";
import ValueCell from "./ValueCell";
import { EnvironmentVariableCell } from "./types";

export const ENV_VARS_CELLS: Record<EnvVariablesColumnId, EnvironmentVariableCell> = {
  [EnvVariablesColumnId.NAME]: NameCell,
  [EnvVariablesColumnId.DESCRIPTION]: DescriptionCell,
  [EnvVariablesColumnId.VALUE]: ValueCell,
  [EnvVariablesColumnId.SOURCE]: SourceCell,
  [EnvVariablesColumnId.CREATED_AT]: TimestampCell,
  [EnvVariablesColumnId.ACTIONS]: EnvVariableActionsCell,
};

export const SPACELIFT_VARS_CELLS: Record<SpaceliftVarsColumnId, EnvironmentVariableCell> = {
  [EnvVariablesColumnId.NAME]: NameCell,
  [EnvVariablesColumnId.DESCRIPTION]: DescriptionCell,
  [EnvVariablesColumnId.VALUE]: ValueCell,
  [EnvVariablesColumnId.ACTIONS]: EmptyActionsCell,
};

export const MOUNTED_FILES_CELLS: Record<string, EnvironmentVariableCell> = {
  [FilesColumnId.NAME]: NameCell,
  [FilesColumnId.DESCRIPTION]: DescriptionCell,
  [FilesColumnId.SECRET]: SecretCell,
  [FilesColumnId.SOURCE]: SourceCell,
  [FilesColumnId.CREATED_AT]: TimestampCell,
  [FilesColumnId.ACTIONS]: MountedFilesActionsCell,
} satisfies Record<FilesColumnId, EnvironmentVariableCell>;

export const ATTACHED_CONTEXTS_CELLS: TableCellPerColumn<StackContextAttachment> = {
  [ContextColumnId.NAME]: ContextNameCell,
  [ContextColumnId.DESCRIPTION]: ContextDescriptionCell,
  [ContextColumnId.ACTIONS]: EmptyActionsCell,
};
